"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const axios_1 = __importDefault(require("axios"));
const errorHandler_1 = require("../../services/errorHandler");
const headers_1 = require("../../services/headers");
const requestEstadoInicial = {
    statusCode: null,
    retorno: null,
    erro: null,
    loading: false,
    descricaoDoErro: '',
};
const useFetch = ({ method, url, headers = {}, comAutenticacao = true, }) => {
    const [request, setRequest] = react_1.useState(requestEstadoInicial);
    const send = async (data) => {
        setRequest(Object.assign(Object.assign({}, requestEstadoInicial), { loading: true }));
        try {
            const headersPadrao = headers_1.getHeadersPadrao(comAutenticacao);
            const { data: retorno } = await axios_1.default({
                method,
                url,
                data,
                headers: Object.assign(Object.assign({}, headers), headersPadrao),
            });
            setRequest({
                statusCode: 200,
                retorno,
                erro: null,
                loading: false,
            });
        }
        catch (err) {
            const descricaoDoErro = errorHandler_1.getDescricaoDoErro(err);
            const { statusCode } = err || {};
            setRequest({
                statusCode,
                retorno: null,
                erro: err,
                descricaoDoErro,
                loading: false,
            });
        }
    };
    return Object.assign(Object.assign({}, request), { send });
};
exports.default = useFetch;
//# sourceMappingURL=index.js.map